import { PercentPipe } from '@angular/common'
import { NgModule } from '@angular/core'

import { SharedModule } from 'primeng/api'
import { ButtonModule } from 'primeng/button'
import { CardModule } from 'primeng/card'
import { ProgressSpinnerModule } from 'primeng/progressspinner'
import { RippleModule } from 'primeng/ripple'

import { GenericModule } from '@app/components/generic/generic.module'

import { LongRunningJobsComponent } from './long-running-jobs-detail'

@NgModule({
  imports: [
    SharedModule,
    ButtonModule,
    CardModule,
    ProgressSpinnerModule,
    GenericModule,
    RippleModule,
    PercentPipe,
    LongRunningJobsComponent,
  ],
  exports: [
    LongRunningJobsComponent,
  ],
})
export class LongRunningJobsModule {}
